import { prefix } from './actions';
import { IRootState } from '../reducer';

export const loading = (state: IRootState) => state[prefix].loading;

export const loadingForm = (state: IRootState) => state[prefix].loadingForm;

export const error = (state: IRootState) => state[prefix].error;

export const successfullyRegistered = (state: IRootState) => state[prefix].successfullyRegistered;

export const experts = (state: IRootState) => state[prefix].experts;

export const expert = (state: IRootState) => state[prefix].expert;
